import React, { FC, FormEvent, KeyboardEvent, useEffect, useState } from 'react'
import s from './GigAssPrompt.module.sass'
import { GigAssRecommendTags } from '@widgets/Common/GigAssist/components/GigAssRecommendTags'
import { GigAssChatForm } from '@widgets/Common/GigAssist/components/GigAssChatForm'
import { sendMessageRequest } from '@widgets/Common/GigAssist/model/actions'
import { RootState, useAppDispatch, useAppSelector } from '@app/model/store'
import { getAssistTagsWithRequestData } from '@widgets/Common/GigAssist/helpers/getAssistTags'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { EGG } from '@shared/api/analytics'

interface Props {
  isShowActive: boolean
}

const GigAssPrompt: FC<Props> = ({ isShowActive }) => {
  const { isMobile, isTablet } = useClientResponsive()
  const messages = useAppSelector((state: RootState) => state.gigAssist.messages)
  const state = useAppSelector((state: RootState) => state.gigAssist.state)

  const dispatch = useAppDispatch()
  const [message, setMessage] = useState<string>('')
  const [currentTags, setCurrentTags] = useState<Array<{ display: string; request: string }>>(null)
  // const shouldFocusInput = useAppSelector((state: RootState) => state.gigAssist.shouldFocusInput)
  // useAutoFocus({ isShowActive, shouldFocusInput, inputRef })

  useEffect(() => {
    if (messages.length === 0) {
      const recommendedTags = getAssistTagsWithRequestData()
      setCurrentTags(recommendedTags)
    }
  }, [messages, state])

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    sendMessage()
  }

  const handleBlur = (e: FormEvent) => {
    e.preventDefault()
    // @ts-ignore
    if (e.relatedTarget?.dataset?.type === 'recommend-tag') {
      setMessage('')
      return
    }
    if (isMobile || isTablet) sendMessage()
  }

  const handleKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      sendMessage()
    }
  }

  const sendMessage = () => {
    EGG.gigachat.send_request()

    if (message.trim() && state !== 'sending' && state !== 'waiting') {
      dispatch(sendMessageRequest(message.trim()))
      setMessage('')
    }
  }

  return (
    <div className={s.wrapper}>
      {currentTags && (
        <GigAssRecommendTags tags={currentTags} isVisible={messages.length === 0} messagesLength={messages.length} />
      )}

      {/* Поле ввода сообщения */}
      <GigAssChatForm
        message={message}
        state={state}
        onMessageChange={setMessage}
        onBlur={handleBlur}
        onSubmit={handleSubmit}
        onKeyPress={handleKeyPress}
        messagesLength={messages.length}
      />
    </div>
  )
}

export default GigAssPrompt
